import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { FiltersResponseSchema } from '../shared/schemas/FiltersSchema.js';

export const get = defaultClient.query({
  url: 'platform_service/platforms/meta/' as const,
  method: 'GET',
  responseSchema: FiltersResponseSchema,
});

export type FiltersOptionsResponse = z.infer<typeof FiltersResponseSchema>;
